import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = createTheme({
  palette: {
    primary: {
      main: '#ffd102', // Admin panel yellow
      contrastText: '#000000', // Black text for contrast
    },
    secondary: {
      main: '#fb923c', // Admin panel orange
    }
  },
  // Smaller type across the whole panel. `fontSize` is MUI's base (default 14) and scales buttons,
  // table cells, inputs, chips and tabs; the headings are set explicitly so page titles stay modest.
  typography: {
    fontFamily: '"Mulish", sans-serif',
    fontSize: 13,
    h1: { fontSize: '2rem' },
    h2: { fontSize: '1.75rem' },
    h3: { fontSize: '1.5rem' },
    h4: { fontSize: '1.25rem' },
    h5: { fontSize: '1.1rem' },
    h6: { fontSize: '0.95rem' },
    subtitle1: { fontSize: '0.9rem' },
    subtitle2: { fontSize: '0.8rem' },
    body1: { fontSize: '0.85rem' },
    body2: { fontSize: '0.78rem' },
    button: { fontSize: '0.8rem' },
    caption: { fontSize: '0.7rem' },
  }
});
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
